module.exports = __webpack_public_path__ + "static/img/qqd.b017b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mother/qqd.png
// module id = DYQp
// module chunks = 1